// extracted by mini-css-extract-plugin
export var complete = "card-badge-module--complete--3NB5h";
export var completeIcon = "card-badge-module--complete-icon--v-TxL";
export var container = "card-badge-module--container--qOcx1";
export var description = "card-badge-module--description--u+spJ";
export var hasProgress = "card-badge-module--hasProgress--KnTz4";
export var inactive = "card-badge-module--inactive--egn-G";
export var noProgress = "card-badge-module--noProgress--1OlHR";
export var root = "card-badge-module--root--EyheP";
export var title = "card-badge-module--title--msIne";